// import NProgress from 'nprogress';
// import 'nprogress/nprogress.css';
import store from '@/store';

// 免登陆直接进入白名单，元素为路由name
const whiteList = ['login'];

// 登陆页登录模式
export async function ssoLogin(routerInstance, to, from, next) {
  const router = routerInstance;
  // NProgress.start();
  // 免登陆直接进的页面路由
  if (whiteList.includes(to.name)) {
    next();
    return;
  }

  // 登陆之后，再访问登陆页面统一跳去根路由
  if (to.path === '/login') {
    next('/');
    return;
  }
  const noUserInfo = JSON.stringify(store.state.currentUser) === '{}';
  if (noUserInfo) {
    try {
      // 获取用户 路由 权限 角色等信息
      const { accessedRoutes } = await store.dispatch('getAppData');
      // 动态挂载路由
      router.options.routes = router.options.routes.concat(accessedRoutes);
      router.addRoutes(accessedRoutes);

      //    路由跳转 hack方法 确保addRoutes已完成
      //    set the replace: true so the navigation will not leave a history record
      const redirect = decodeURIComponent(from.query.redirect || to.path);
      next(to.path === redirect ? { ...to, replace: true } : { path: redirect });
    } catch (error) {
      next({ path: '/500' });
    }
  } else {
    next();
  }
}

export default {
  ssoLogin,
};
